export function redirectToNewJourney(
  destination: string,
  location: Pick<Location, 'href' | 'search' | 'replace'>
): void {
  const target = new URL(destination);

  if (target.protocol !== 'https:' && target.protocol !== 'http:') {
    throw new Error('jornadaNova must be an absolute HTTP(S) URL.');
  }

  const current = new URL(location.href);
  if (target.origin === current.origin && target.pathname === current.pathname) {
    throw new Error('jornadaNova must not point to the current page.');
  }

  new URLSearchParams(location.search).forEach((value, key) => {
    target.searchParams.append(key, value);
  });

  location.replace(target.href);
}
